import { useCarConfigSelector } from "../redux/store";
import type { ServiceType } from "../../../../common-deprecated/types/SettingsType";
import { showAemInsuranceRates } from "../../../../common-deprecated/settings/utils/financeSettingUtilsAem";
import { AemFmComponent } from "../../../../common-deprecated/utils/aemFlexibilityMatrixUtils";

const useCarConfigServices = (): ServiceType[] | null => {
    const services = useCarConfigSelector((state) => state.carConfigSettings.services);
    const commonSettings = useCarConfigSelector((state) => state.commonSettings);
    const { internalCode } = useCarConfigSelector((state) => state.car.model);

    const insuranceEnabled = showAemInsuranceRates(commonSettings, AemFmComponent.Carconfig, "new", internalCode);

    if (!services?.length) return null;

    return services.filter((service) => service.type === "insurance" && insuranceEnabled);
};

export default useCarConfigServices;
